import { InputCpfCnpj, InputCurrency, InputDatePicker, InputDecimal, InputPadrao, InputSwitch, InputValor, InputValorNovo, TextArea } from '../../../../components/Inputs'
import React, { useState, useEffect, useRef, useMemo, useDebugValue, useCallback } from 'react'
import ReactDOM from 'react-dom'
import { Formik, Form, FieldArray } from "formik"
import { mostrarToast } from '../../../../components/Toasts'
import { BotaoPadrao } from '../../../../components/Botoes'
import { get, getComAuditoria, salvar } from '../../../../util/AcessoApi'
import { Link, useParams } from "react-router-dom"
import { arredondarBancario, buscarCep, convertValueToFloat, formatarMoeda, mensagens } from '../../../../util/Utilitarios'
import Yup from '../../../../util/Validacoes'
import '../../../../assets/css/ios-switch/clean-switch.css'
import 'react-circular-progressbar/dist/styles.css'
import 'react-toastify/dist/ReactToastify.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import Atalho from '../../../../util/Atalho'
import { HeaderCadastro } from '../../../../components/Headers'
import { InputBanco, InputClienteFinanceiro, InputEmpresa, InputEmpresaCliente, InputLancamentoFinanceiro, InputLancamentoFinanceiroPorCliente, InputLancamentoSemMovimento, InputMunicipio, InputRecolhimentoTributo, InputSituacaoTributo, InputTributo, InputCnaeByEmpresa, InputListaServicoByCnae, InputNbsByListaServico, InputNaturezaOperacao, InputPisCofinsSituacaoTributaria, InputPisCofinsCsllTipoRetencao, InputIbsCbsIndicadorOperacao, InputIbsCbsSituacaoTributaria, InputIbsCbsClassificacaoTributaria, InputAtividadeMunicipal } from '../../../../components/InputsAutoComplete'
import moment from 'moment'
import { Overlay, Tooltip } from 'react-bootstrap'
import { FiAlertTriangle } from 'react-icons/fi'
import { BtnAcao } from '../../../../components/Acoes'
import { InputClienteFinanceiroV2, InputClienteFinanceiroV3, InputLocalIncidencia, InputLoteLancamento, InputTodosLancamentoFinanceiroPorCliente } from '../../../../components/InputsAutoCompleteV2'
import { ModalDuasOpcoes } from '../../../../components/Modais'
import { getUsuario } from '../../../../util/Configuracoes'
import { useHistory } from 'react-router-dom'
import { MODULOS_SISTEMA } from '../../../../util/Enums'


const CadastroNotaFiscal = (props) => {
    let { id } = useParams()
    const history = useHistory()


    const [salvarENovo, setSalvarENovo] = useState(false)
    const [salvando, setSalvando] = useState(false)
    const [valoresIniciais, setValoresIniciais] = useState({})
    const [devolvido, setDevolvido] = useState(false)
    const inputValor = useRef();
    const inputValorLancamento = useRef([]);
    const inputValorDesconto = useRef();
    const inputBaseCalculo = useRef();
    const inputValorDeducao = useRef();
    const inputValorNota = useRef();
    const inputValorTributo = useRef([]);
    const refTributos = useRef(null)
    // Município|data com que as linhas obrigatórias (CBS/IBS) da grade foram montadas;
    // null até a tela carregar
    const chaveTributosObrigatorios = useRef(null)
    const refLancamentos = useRef(null)
    const idLancamento = history.location.state && history.location.state.idLancamento ? history.location.state.idLancamento : null
    const idSubstituicao = history.location.state && history.location.state.idSubstituicao ? history.location.state.idSubstituicao : null
    const empresaSubstituicao = history.location.state && history.location.state.empresaSubstituicao ? history.location.state.empresaSubstituicao : null
    const idMovimentoFixo = history.location.state && history.location.state.idMovimento ? history.location.state.idMovimento : false
    const idGuiaParticular = history.location.state && history.location.state.idGuiaParticular ? history.location.state.idGuiaParticular : null

    const validacao = Yup.lazy(({ lancamentos, tributos }) => Yup.object({
        numero: Yup.string().nullable(),
        codigo_verificacao: Yup.string().nullable(),
        cliente: Yup.object().required().nullable(),
        empresa: Yup.object().required().nullable(),
        municipio: Yup.object().required().nullable(),
        cnae: Yup.object().required().nullable(),
        lista_servico: Yup.object().required().nullable(),
        nbs: Yup.object().required().nullable(),
        natureza_operacao: Yup.object().required().nullable(),
        informacoes_adicionais: Yup.string().nullable(),
        discriminacao_servicos: Yup.string().required().nullable()
    }).shape({
        lancamentos: Yup.array()
            .test('Lançamentos', 'Insira ao menos 1 Lançamentos', function (value) {
                return (this.parent?.lancamentos && this.parent?.lancamentos[0]?.lancamento !== null) || (this.parent?.lancamentos && this.parent?.lancamentos[0]?.valor_lancamento !== null && this.parent?.lancamentos[0]?.valor_lancamento !== 0)
            })
            .of(
                Yup.object().shape({
                    lancamento: Yup.object().nullable().test('Lançamento', 'Campo Obrigatório!', function (value) {
                        const index = this.path.replace(/[^0-9]+/g, '');
                        return !(lancamentos.length - 1 != index && !value)
                    }),
                    valor_lancamento: Yup.number().nullable().test('Valor Acréscimo', 'Campo Obrigatório!', function (value) {
                        const index = this.path.replace(/[^0-9]+/g, '');
                        return !(lancamentos.length - 1 != index && !value)
                    })
                })
            ),
        tributos: Yup.array()
            .test('Tributos', 'Insira ao menos 1 Tributo', function (value) {
                return this.parent.tributos && this.parent.tributos[0].situacao !== null
            })
            .of(
                Yup.object().shape({
                    recolhimento: Yup.object().nullable().test('Recolhimento', 'Campo Obrigatório!', function (value) {
                        const index = this.path.replace(/[^0-9]+/g, '');
                        return !(tributos.length - 1 != index && !value)
                    }),
                    situacao: Yup.object().nullable().test('Situação', 'Campo Obrigatório!', function (value) {
                        const index = this.path.replace(/[^0-9]+/g, '');
                        return !(tributos.length - 1 != index && !value)
                    }),
                    tributo: Yup.object().nullable().test('Tributo', 'Campo Obrigatório!', function (value) {
                        const index = this.path.replace(/[^0-9]+/g, '');
                        return !(tributos.length - 1 != index && !value)
                    }).test('Tributo Repetido', 'Tributo já cadastrado!', function (value) {
                        const index = this.path.replace(/[^0-9]+/g, '');
                        let tributoArray = tributos.length > 0 ? tributos?.filter(x => !x?.alteracao).map(x => x.tributo).filter(x => x) : [];
                        let idTributo = tributoArray.map(x => x.value)
                        let possui_duplicidade = new Set(idTributo).size !== idTributo.length;
                        return !possui_duplicidade;
                    })
                })
            ),
    }))

    const [valorTotalLancamentos, setValorTotalLancamentos] = useState(0)
    const [showModalImportarLote, setShowModalImportarLote] = useState(false)
    const [loteSelecionado, setLoteSelecionado] = useState(null)
    const [importandoLote, setImportandoLote] = useState(false)
    // Tomador substituto tributário no cadastro do cliente (por empresa). Só sugere a flag
    // "ISS retido"; null = ainda não consultado (falta cliente ou empresa).
    const [substitutoCadastro, setSubstitutoCadastro] = useState(null)
    // Estado mais recente do Formik, para quem continua depois de um await (consulta do
    // tomador, busca do tributo de ISS): o propsFormik da chamada pode já estar desatualizado
    const formikRef = useRef(null)

    const Submit = (values, propsFormik) => {

        setSalvando(true)
        values.usuario_id = getUsuario().id

        if (idSubstituicao) {
            values["nf_substituida_id"] = idSubstituicao;
        }

        salvar(
            values,
            '/financeiro/notafiscal',
            () => {
                mostrarToast('sucesso', mensagens.sucesso)
                if (salvarENovo) {
                    propsFormik.resetForm({})
                    // manter.forEach(x => propsFormik.setFieldValue(x, values[x]))
                    setSubstitutoCadastro(null)
                    setSalvando(false)
                    setSalvarENovo(false)
                }
                else
                    props.history.push('/financeiro/notafiscal/consulta')

                setSalvando(false)
            }, (err) => {
                mostrarToast('erro', mensagens.erro)
                setSalvando(false)
            })
    }

    const popularPorLancamento = async () => {
        if (idLancamento && idLancamento > 0) {
            let valoresLancamento;
            const municipioPadrao = { label: 'GOIANIA - GO', value: 5208707 }
            const tributosObrigatorios = await carregarTributosObrigatorios(municipioPadrao.value, '')

            await Promise.resolve(getComAuditoria(`/financeiro/lancamento/${idLancamento}`, { modulo: MODULOS_SISTEMA.LANCAMENTO, id: idLancamento })).then(val => {
                valoresLancamento = {
                    empresa: val.empresa,
                    cliente: val.cliente_lancamento,
                    lancamentos: [],
                    municipio: municipioPadrao,
                    tributos: [
                        ...montarTributosObrigatorios(tributosObrigatorios),
                        { situacao: { label: 'Tributável', value: 1 }, recolhimento: { label: 'Retido na Fonte', value: 1 }, tributo: null, valor_tributo: 0, disabled: true, local_incidencia: { value: 2, label: 'Tomador' } }
                    ],
                    anotacao: ''
                }
            });

            await Promise.resolve(get('/financeiro/lancamentoFinanceiroTodosCombo', { pesquisa: '', cliente_id: valoresLancamento.cliente?.value || 0, valor_setado: [0], id_pesquisa: idLancamento }, null, null)).then(value => {
                const lancamentoCampo = value[0];
                const valorLancamentoFormatado = lancamentoCampo?.valor_lancamento;
                const valorLancamento = convertValueToFloat(lancamentoCampo?.valor_lancamento);
                valoresLancamento.lancamentos.push({ lancamento: lancamentoCampo, valor_lancamento: valorLancamento, valor_lancamento_formatado: valorLancamentoFormatado })
                valoresLancamento.valor_servico = valorLancamento;
                valoresLancamento.valor_servico_formatado = valorLancamentoFormatado;
                valoresLancamento.valor_base_calculo = valorLancamento;
                valoresLancamento.valor_base_calculo_formatado = valorLancamentoFormatado;
                inputBaseCalculo.current = valorLancamentoFormatado
                setValorTotalLancamentos(valorLancamentoFormatado)
                valoresLancamento.valor_nota = valorLancamento;
                valoresLancamento.valor_nota_formatado = valorLancamentoFormatado;
            })
            valoresLancamento.lancamentos.push({ lancamento: null, valor_lancamento: 0 })

            // Flag "ISS retido" sugerida pelo cadastro do tomador (substituto tributário)
            try {
                valoresLancamento.iss_retido = !!(await consultarTomadorSubstituto(valoresLancamento.cliente, valoresLancamento.empresa))
                const tributoIss = valoresLancamento.iss_retido ? await buscarTributoIss(municipioPadrao.value, '') : null
                if (tributoIss)
                    valoresLancamento.tributos.splice(valoresLancamento.tributos.length - 1, 0, linhaIssNova(tributoIss))
            } catch (e) {
                valoresLancamento.iss_retido = false
                mostrarToast('erro', 'Não foi possível consultar se o tomador é substituto tributário. Confira a flag "ISS retido".')
            }

            chaveTributosObrigatorios.current = `${valoresLancamento.municipio.value}|`
            setValoresIniciais(valoresLancamento);
        }
    }


    const montarTributosObrigatorios = (tributosObrigatorios) => {
        return (tributosObrigatorios || []).map(t => ({
            situacao: { label: 'Tributável', value: 1 },
            recolhimento: { label: 'Retido na Fonte', value: 1 },
            tributo: t,
            valor_tributo: 0,
            disabled: true,
            local_incidencia: { value: 2, label: 'Tomador' },
            obrigatorio: true
        }))
    }

    // ---- ISS retido ----
    // A flag "ISS retido" da nota decide a retenção; o cadastro do tomador (substituto
    // tributário, por empresa) só sugere. A linha de ISS da grade é consequência da flag:
    // retido -> uma linha travada, como CBS/IBS; não retido -> nenhuma. O servidor refaz a
    // mesma regra ao salvar (nota-fiscal.service, sincronizarLinhaIss).
    const ehLinhaIss = (linha) => linha?.tributo?.tipo_tributo?.toUpperCase() === 'ISS'

    const linhaIssNova = (tributo) => ({
        situacao: { label: 'Tributável', value: 1 },
        recolhimento: { label: 'Retido na Fonte', value: 1 },
        tributo,
        valor_tributo: 0,
        disabled: true,
        local_incidencia: { value: 2, label: 'Tomador' }
    })

    // Tributo de ISS da linha (mesmo combo da grade): o que tem alíquota cadastrada para o
    // município; sem nenhum, o primeiro ISS. É só o rótulo — o valor sai da atividade.
    const buscarTributoIss = async (municipio, dataEmissao) => {
        const opcoes = await get('/financeiro/tributoCombo', { pesquisa: '', municipio: municipio || '', data_emissao: dataEmissao || '' }, null, null) || []
        const temAliquotaNoMunicipio = (o) => /_\d+$/.test(String(o.value)) ? 1 : 0
        return opcoes
            .filter(o => o?.tipo_tributo?.toUpperCase() === 'ISS')
            .sort((a, b) => temAliquotaNoMunicipio(b) - temAliquotaNoMunicipio(a) || Number(a.cod) - Number(b.cod))[0] || null
    }

    // Cadastro do tomador: true/false, ou null sem cliente/empresa
    const consultarTomadorSubstituto = async (cliente, empresa) => {
        const clienteId = cliente?.value
        const empresaId = empresa?.value ?? empresa?.id
        if (!clienteId || !empresaId) {
            setSubstitutoCadastro(null)
            return null
        }
        const retorno = await get('/financeiro/notaFiscalTomadorSubstituto', { cliente_id: clienteId, empresa_id: empresaId }, null, null)
        const substituto = !!retorno?.substituto
        setSubstitutoCadastro(substituto)
        return substituto
    }

    // Tributos obrigatórios (CBS/IBS) vigentes na data de emissão — sem data, hoje, como na emissão
    const carregarTributosObrigatorios = (municipio, dataEmissao) =>
        get('/financeiro/tributosObrigatorios', { municipio: municipio || '', data_emissao: dataEmissao || '' }, null, null)

    // A linha obrigatória assume o tributo vigente (alíquota da vigência) e sai da grade
    // quando o tributo deixa de valer; os vigentes que faltam entram no início.
    const aplicarTributosObrigatorios = (linhas, obrigatorios) => {
        const vigente = (linha) => obrigatorios.find(o => o.cod === linha?.tributo?.cod)
        const mantidas = linhas
            .filter(linha => !linha.obrigatorio || vigente(linha))
            .map(linha => vigente(linha) ? { ...linha, tributo: vigente(linha), obrigatorio: true } : linha)
        const faltantes = obrigatorios.filter(o => !linhas.some(linha => linha?.tributo?.cod === o.cod))
        return [...montarTributosObrigatorios(faltantes), ...mantidas]
    }

    // Troca de data de emissão ou município refaz as linhas obrigatórias e os valores
    const sincronizarTributosObrigatorios = async (propsFormik, municipio, dataEmissao) => {
        if (chaveTributosObrigatorios.current === null) return
        const chave = `${municipio?.value || ''}|${dataEmissao || ''}`
        if (chave === chaveTributosObrigatorios.current) return
        chaveTributosObrigatorios.current = chave
        try {
            const obrigatorios = await carregarTributosObrigatorios(municipio?.value, dataEmissao)
            if (chave !== chaveTributosObrigatorios.current) return // trocou de novo antes da resposta
            propsFormik.values.tributos = aplicarTributosObrigatorios(propsFormik.values.tributos || [], obrigatorios)
            propsFormik.setFieldValue('tributos', propsFormik.values.tributos)
            calcularValorTributo(propsFormik)
        } catch (e) {
            chaveTributosObrigatorios.current = ''
            mostrarToast('erro', mensagens.erro)
        }
    }

    useEffect(_ => {
        var objListas = {
            lancamentos: [{ lancamento: null, valor_lancamento: 0 }],
            tributos: [{ situacao: { label: 'Tributável', value: 1 }, recolhimento: { label: 'Retido na Fonte', value: 1 }, tributo: null, valor_tributo: 0, disabled: true, local_incidencia: { value: 2, label: 'Tomador' } }]
            ,
        }
        if (!props.modal && (id || idSubstituicao)) {

            Promise.resolve(get(`/financeiro/notafiscal/${id || idSubstituicao}`)).then(async val => {
                val.lancamentos = [...val.lancamentos.map(x => ({ alteracao: true, ...x })), ...objListas.lancamentos];

                // A substituta sai com a data de hoje (a data da substituída é limpa abaixo)
                const dataVigencia = idSubstituicao ? '' : val.data_emissao
                const tributosObrigatorios = await carregarTributosObrigatorios(val.municipio?.value, dataVigencia)

                val.tributos = [
                    ...aplicarTributosObrigatorios((val.tributos || []).map(x => ({ alteracao: true, ...x })), tributosObrigatorios),
                    ...objListas.tributos
                ];
                chaveTributosObrigatorios.current = `${val.municipio?.value || ''}|${dataVigencia || ''}`

                if (idSubstituicao) {
                    val.id = undefined;
                    val.numero = undefined;
                    val.data_emissao = undefined;
                    val.numero_rps = undefined;
                    val.codigo_verificacao = undefined;


                    console.log('val: ', val);
                }

                // Base do PIS/COFINS gravada: marca como editada pra sugestao (que segue o
                // valor da nota) nao sobrescrever o que veio do banco, e monta o formatado
                // que alimenta o input controlado.
                if (convertValueToFloat(val.base_calculo_pis_cofins) > 0) {
                    val.base_pis_cofins_editada = true
                    val.base_calculo_pis_cofins_formatado = formatarMoeda(convertValueToFloat(val.base_calculo_pis_cofins))
                }

                // A flag gravada manda; o cadastro do tomador só alimenta o aviso de divergência
                val.iss_retido = !!val.iss_retido
                setValoresIniciais(val)
                setValorTotalLancamentos(convertValueToFloat(val.valor_base_calculo))
                consultarTomadorSubstituto(val.cliente, val.empresa).catch(() => setSubstitutoCadastro(null))

            })
        } else if (idLancamento) {
            popularPorLancamento();
        }
        else {
            const municipioPadrao = { label: 'GOIANIA - GO', value: 5208707 }
            Promise.all([
                carregarTributosObrigatorios(municipioPadrao.value, ''),
                get('/financeiro/pisCofinsSituacaoTributariaCombo', {}, null, null),
            ]).then(([tributosObrigatorios, situacoesPisCofins]) => {
                const situacaoPadrao = (situacoesPisCofins || []).find(s => s.padrao) || null;
                chaveTributosObrigatorios.current = `${municipioPadrao.value}|`

                setValoresIniciais({
                    banco: '',
                    agencia: '',
                    agencia_digito: '',
                    conta: '',
                    conta_digito: '',
                    numero: '',
                    valor: '',
                    nominal: '',
                    data_emissao: '',
                    data_predatado: '',
                    data_compensado: '',
                    data_devolucao: '',
                    devolvido: false,
                    empresa: empresaSubstituicao || null,
                    municipio: municipioPadrao,
                    cnae: null,
                    lista_servico: null,
                    nbs: null,
                    empresa_atividade_municipal: null,
                    natureza_operacao: null,
                    iss_retido: false,
                    pis_cofins_situacao_tributaria: situacaoPadrao,
                    base_calculo_pis_cofins: 0,
                    base_pis_cofins_editada: false,
                    ibs_cbs_indicador_operacao: null,
                    ibs_cbs_classificacao_tributaria: null,
                    ibs_cbs_situacao_tributaria: null,
                    lancamentos: [{ lancamento: null, valor_lancamento: 0 }],
                    tributos: [
                        ...montarTributosObrigatorios(tributosObrigatorios),
                        { situacao: { label: 'Tributável', value: 1 }, recolhimento: { label: 'Retido na Fonte', value: 1 }, tributo: null, valor_tributo: 0, disabled: true, local_incidencia: { value: 2, label: 'Tomador' } }
                    ],
                    anotacao: ''

                })
            })
        }
    }, [id, props.modal])

    const links = [
        () => <Link to={'/dashboard'}>Dashboard</Link>,
        () => <span>Financeiro</span>,
        () => <Link className='link-active' to={'/financeiro/notafiscal/consulta'}>Nota Fiscal</Link>,
    ]
    const adicionarLinhaLancamento = (arrayHelpers, propsFormik, index) => {

        if (propsFormik.values.lancamentos.length - 1 === index)
            arrayHelpers.insert(propsFormik.values.lancamentos.length, { lancamento: undefined, valor_lancamento: undefined })
    };

    const adicionarLinhaTributo = (arrayHelpers, propsFormik, index) => {
        if (propsFormik.values.tributos.length - 1 === index)
            arrayHelpers.insert(propsFormik.values.tributos.length, { situacao: undefined, recolhimento: undefined, local_incidencia: { value: 2, label: 'Tomador' }, tributo: undefined, valor: 0 })

    }

    const removerLinhaLancamento = (arrayHelpers, propsFormik, index) => {

        const arrayLancamento = propsFormik.values.lancamentos;
        if (arrayLancamento.length === 1) {
            propsFormik.setFieldValue('lancamentos', [{ lancamento: undefined, valor_lancamento: undefined }])
            propsFormik.values.lancamentos = [{ lancamento: undefined, valor_lancamento: undefined }]
        } else {
            if (index + 1 !== arrayLancamento.length) {

                let copiaObj = [...propsFormik.values.lancamentos]
                copiaObj.splice(index, 1)
                propsFormik.values.lancamentos = copiaObj
                // arrayHelpers.remove(index)
                inputValorLancamento.current.splice(index, 1)
            }

            if (arrayLancamento.length === 1 && arrayLancamento[index].lancamento && arrayLancamento[index].lancamento.value) {
                let copiaObj = [...propsFormik.values.lancamentos]
                copiaObj.splice(index, 1)
                copiaObj = [{ lancamento: undefined, valor_lancamento: undefined }]
                propsFormik.values.lancamentos = copiaObj
                arrayHelpers.remove(index)
                arrayHelpers.insert(propsFormik.values.lancamentos.length, { lancamento: undefined, valor_lancamento: undefined })
            }
        }
        somarValorLancamentos(propsFormik)

    }

    const removerLinhaTributo = (arrayHelpers, propsFormik, index) => {

        const arrayTributo = propsFormik.values.tributos;
        // CBS/IBS são obrigatórios; o ISS sai desmarcando a flag "ISS retido"
        if (arrayTributo[index]?.obrigatorio || ehLinhaIss(arrayTributo[index])) return;
        if (arrayTributo.length === 1) {
            propsFormik.setFieldValue('tributos', [{
                situacao: undefined, recolhimento: undefined, tributo: undefined, valor_tributo: 0, valor_tributo_formatado
                    : 'R$ 0,00'
            }])
        } else {

            if (index + 1 !== arrayTributo.length) {
                let copiaObj = [...propsFormik.values.tributos]
                copiaObj.splice(index, 1)
                propsFormik.values.tributos = copiaObj
                // arrayHelpers.remove(index)
            }

            if (arrayTributo.length === 1 && arrayTributo[index].tributo && arrayTributo[index].tributo.value) {
                let copiaObj = [...propsFormik.values.tributos]
                copiaObj.splice(index, 1)
                copiaObj = [{
                    situacao: undefined, recolhimento: undefined, tributo: undefined, valor_tributo: 0, valor_tributo_formatado
                        : 'R$ 0,00'
                }]
                propsFormik.values.tributos = copiaObj
                arrayHelpers.insert(propsFormik.values.tributos.length, {
                    situacao: undefined, recolhimento: undefined, tributo: undefined, valor_tributo: 0, valor_tributo_formatado
                        : 'R$ 0,00'
                })
            }
        }
    }

    const importarLancamentosDoLote = (propsFormik) => {
        if (!loteSelecionado?.value) {
            mostrarToast('erro', 'Selecione um lote.')
            return
        }
        setImportandoLote(true)
        Promise.resolve(get(`/financeiro/lancamentoFinanceiroComboPorLote/${loteSelecionado.value}`))
            .then(val => {
                const itens = val || []
                const lancamentosAtuais = (propsFormik.values.lancamentos || []).filter(x => x.lancamento?.value)
                const valoresExistentes = new Set(lancamentosAtuais.map(l => l.lancamento?.value))
                const novos = itens
                    .filter(opt => !valoresExistentes.has(opt.value))
                    .map(opt => ({
                        lancamento: opt,
                        valor_lancamento: convertValueToFloat(opt.valor_lancamento),
                        valor_lancamento_formatado: opt.valor_lancamento
                    }))
                if (!novos.length) {
                    mostrarToast('erro', 'Nenhum lançamento novo para importar.')
                    setImportandoLote(false)
                    return
                }
                const novaLista = [...lancamentosAtuais, ...novos]
                const empresaDoLote = novos.find(n => n.lancamento?.empresa?.id)?.lancamento?.empresa

                // React 16 não agrupa (batch) atualizações dentro de callbacks de Promise.
                // Sem isso, cada setFieldValue re-renderiza toda a lista de selects (pesados),
                // travando a tela ao popular. Agrupando, tudo vira um único render.
                ReactDOM.unstable_batchedUpdates(() => {
                    propsFormik.setFieldValue('lancamentos', novaLista)

                    if (empresaDoLote && !propsFormik.values.empresa) {
                        const emp = empresaDoLote
                        const empresaOption = {
                            value: emp.id,
                            label: emp.cnpj && emp.nome ? `${emp.cnpj} - ${emp.nome}` : (emp.label ?? emp.nome ?? ''),
                            cnpj: emp.cnpj,
                            nome: emp.nome
                        }
                        propsFormik.setFieldValue('empresa', empresaOption)
                        propsFormik.values.empresa = empresaOption
                        sugerirIssRetido(propsFormik, propsFormik.values.cliente, empresaOption)
                    }

                    somarValorLancamentos({ ...propsFormik, values: { ...propsFormik.values, lancamentos: novaLista } })
                    setShowModalImportarLote(false)
                    setLoteSelecionado(null)
                    setImportandoLote(false)
                })

                mostrarToast('sucesso', `${novos.length} lançamento(s) importado(s).`)
            })
            .catch(() => {
                mostrarToast('erro', 'Erro ao importar lançamentos.')
                setImportandoLote(false)
            })
    }

    const somarValorLancamentos = (propsFormik) => {
        let desconto = 0

        let valorLancamentos = propsFormik.values.lancamentos.filter(x => x.valor_lancamento).map(x => convertValueToFloat(x.valor_lancamento))
        let valorTotal = valorLancamentos.reduce((acc, valor) => acc + valor, 0)
        desconto = convertValueToFloat(propsFormik.values.valor_desconto || 0)
        valorTotal = valorTotal - desconto
        propsFormik.setFieldValue('valor_servico', valorTotal)
        propsFormik.setFieldValue('valor_servico_formatado', formatarMoeda(valorTotal))
        propsFormik.setFieldValue('valor_base_calculo', valorTotal)
        propsFormik.setFieldValue('valor_base_calculo_formatado', formatarMoeda(valorTotal))

        // Base do PIS/COFINS acompanha a base da nota enquanto o usuario nao editar.
        // Depois de editado, o valor dele manda (flag base_pis_cofins_editada).
        if (!propsFormik.values.base_pis_cofins_editada) {
            propsFormik.setFieldValue('base_calculo_pis_cofins', valorTotal)
            propsFormik.values.base_calculo_pis_cofins = convertValueToFloat(valorTotal)
            // O input e controlado por (formatado || cru): sem atualizar o formatado, a
            // sugestao nao aparece no campo.
            propsFormik.setFieldValue('base_calculo_pis_cofins_formatado', formatarMoeda(convertValueToFloat(valorTotal)))
            propsFormik.values.base_calculo_pis_cofins_formatado = formatarMoeda(convertValueToFloat(valorTotal))
        }

        //GERAR O VALOR DA NOTA INSTANTANEAMENTE
        propsFormik.values.valor_base_calculo = convertValueToFloat(valorTotal)
        propsFormik.values.valor_base_calculo_formatado = formatarMoeda(valorTotal)

        inputBaseCalculo.current = valorTotal
        // calculaTodosTributos(propsFormik)
        setValorTotalLancamentos(valorTotal)
        calcularValorTributo(propsFormik)
    }

    // Reforma Tributária: pré-popula o "Tipo de Retenção do PIS/COFINS/CSLL" com base
    // na empresa selecionada e no tipo de pessoa do cliente (CNPJ ou CPF).
    // - Empresas EQUIPE/ALFA: CNPJ retém, CPF não retém
    // - Empresa SAAGA: CNPJ retém, CPF NULL (não emite pra PF — usuário escolhe)
    // - Se a empresa não tiver default configurado, deixa o campo intacto.
    // Retorna:
    //   - undefined -> dados insuficientes (falta empresa, cliente ou identificacao). Nao atualiza o campo.
    //   - null      -> combinacao valida mas sem default configurado (ex: SAAGA + CPF). Limpa o campo.
    //   - objeto    -> default a aplicar.
    const calcularRetencaoPadraoPisCofinsCsll = (empresa, cliente) => {
        if (!empresa || !cliente) return undefined;
        const identificacao = (cliente.identificacao || '').replace(/\D/g, '');
        if (!identificacao) return undefined;
        const ehPessoaJuridica = identificacao.length === 14;
        const retencao = ehPessoaJuridica
            ? empresa.pis_cofins_csll_retencao_cnpj
            : empresa.pis_cofins_csll_retencao_cpf;
        return retencao || null;
    }

    const aplicarReducaoIbsCbs = (propsFormik, tributo, aliquotaBase) => {
        const classif = propsFormik.values.ibs_cbs_classificacao_tributaria;
        if (!classif) return aliquotaBase;
        const nome = tributo?.tipo_tributo?.toUpperCase();
        let reducao = 0;
        if (nome === 'CBS') reducao = parseFloat(classif.percentual_reducao_cbs || 0) / 100;
        else if (nome === 'IBS') reducao = parseFloat(classif.percentual_reducao_ibs || 0) / 100;
        else return aliquotaBase;
        return aliquotaBase * (1 - reducao);
    }

    // CST nunca é escolhido: deriva da classificação (3 primeiros dígitos do cClassTrib)
    const derivarSituacaoTributaria = (propsFormik, classificacao) => {
        const situacao = classificacao?.situacao_tributaria_id
            ? { value: classificacao.situacao_tributaria_id, label: `${classificacao.situacao_codigo} - ${classificacao.situacao_descricao}` }
            : null
        propsFormik.setFieldValue('ibs_cbs_situacao_tributaria', situacao)
        propsFormik.values.ibs_cbs_situacao_tributaria = situacao
    }

    // Cascata IBS/CBS (correlação Anexo VIII): (item lista + NBS) restringe os
    // indicadores; (item + NBS + indicador) restringe as classificações. Quando
    // sobra uma única opção válida (ou a padrão está entre as válidas), auto-seleciona
    // — mesmo comportamento do form da prefeitura.
    const selecionarClassificacao = (propsFormik, classificacao) => {
        propsFormik.setFieldValue('ibs_cbs_classificacao_tributaria', classificacao)
        propsFormik.values.ibs_cbs_classificacao_tributaria = classificacao
        derivarSituacaoTributaria(propsFormik, classificacao)
        calcularValorTributo(propsFormik)
    }

    const cascataAposIndicador = async (propsFormik, listaServico, nbs, indicador) => {
        selecionarClassificacao(propsFormik, null)
        if (!listaServico?.value || !nbs?.value || !indicador?.value) return
        const classificacoes = await Promise.resolve(get('/financeiro/ibsCbsClassificacaoTributariaCombo',
            { lista_servico_id: listaServico.value, nbs_id: nbs.value, indicador_operacao_id: indicador.value }, null, null)) || []
        const escolhida = classificacoes.length === 1 ? classificacoes[0] : classificacoes.find(c => c.padrao)
        if (escolhida) selecionarClassificacao(propsFormik, escolhida)
    }

    const cascataAposServicoNbs = async (propsFormik, listaServico, nbs) => {
        propsFormik.setFieldValue('ibs_cbs_indicador_operacao', null)
        propsFormik.values.ibs_cbs_indicador_operacao = null
        selecionarClassificacao(propsFormik, null)
        if (!listaServico?.value || !nbs?.value) return
        const indicadores = await Promise.resolve(get('/financeiro/ibsCbsIndicadorOperacaoCombo',
            { lista_servico_id: listaServico.value, nbs_id: nbs.value }, null, null)) || []
        if (indicadores.length === 1) {
            propsFormik.setFieldValue('ibs_cbs_indicador_operacao', indicadores[0])
            propsFormik.values.ibs_cbs_indicador_operacao = indicadores[0]
            await cascataAposIndicador(propsFormik, listaServico, nbs, indicadores[0])
        }
    }

    // A Situacao Tributaria do PIS/COFINS e o interruptor do bloco federal: quando o CST
    // nao pede apuracao (apura_pis_cofins do cadastro) o payload NAO leva base, aliquotas
    // nem valores de PIS/COFINS — pra prefeitura eles nao existem na nota.
    // Logo tambem nao entram na deducao nem reduzem a base do IBS/CBS (comprovado na
    // nota 4854 do SGCM). Espelha apuraPisCofins do nota-fiscal.service.
    const apuraPisCofinsSelecionado = (propsFormik) =>
        propsFormik.values.pis_cofins_situacao_tributaria?.apura_pis_cofins === true

    // Atividade municipal (cTribMun) tem que ser do mesmo item da lista (cTribNac): a
    // prefeitura recusa o par cruzado com EM020 (04.11.01 x 401, nota 4843 da SAAG). Ao
    // trocar a lista, sugere a atividade de código igual ao item (04.11 -> 411); o usuário
    // pode trocar. Sem atividade correspondente (códigos especiais), não mexe.
    const sugerirAtividadePelaLista = async (propsFormik, listaServico) => {
        const empresaId = propsFormik.values.empresa?.value
        const codigoItem = (listaServico?.code || listaServico?.label || '').replace(/\D/g, '').slice(0, 4)
        if (!empresaId || codigoItem.length < 4) return
        const codigoAtividade = String(parseInt(codigoItem, 10))
        if (String(propsFormik.values.empresa_atividade_municipal?.codigo || '') === codigoAtividade) return
        const atividades = (await get('/financeiro/atividadeMunicipalCombo', { empresa_id: empresaId }, null, null)) || []
        const sugerida = atividades.find(a => String(a.codigo) === codigoAtividade && !a.desativado)
        if (!sugerida) return
        propsFormik.setFieldValue('empresa_atividade_municipal', sugerida)
        propsFormik.values.empresa_atividade_municipal = sugerida
        calcularValorTributo(propsFormik)
    }

    // Alíquota do ISS apurado (percentual): a da atividade municipal, que é a que a
    // prefeitura aplica (ela ignora a enviada pelo não optante — E0617). Fora de Operação
    // tributável (Imunidade, Exportação, Não Incidência) não há ISS: 0.
    // null = atividade sem alíquota cadastrada (vale a alíquota da linha, regra antiga).
    // Espelha aliquotaIssApurado do nota-fiscal.service.
    const aliquotaIssApurado = (propsFormik) => {
        const aliquota = propsFormik.values.empresa_atividade_municipal?.aliquota
        if (aliquota === null || aliquota === undefined || aliquota === '') return null
        const natureza = propsFormik.values.natureza_operacao
        const codigo = natureza?.code ?? natureza?.codigo
        if (codigo !== null && codigo !== undefined && Number(codigo) !== 1) return 0
        return convertValueToFloat(aliquota)
    }

    // Retido -> uma linha de ISS (criada se faltar); não retido -> nenhuma
    const sincronizarLinhaIss = async (propsFormik) => {
        let linhas = propsFormik.values.tributos || []
        const linhasIss = linhas.filter(ehLinhaIss)

        if (!propsFormik.values.iss_retido) {
            linhas = linhas.filter(linha => !ehLinhaIss(linha))
        } else if (linhasIss.length) {
            // Uma linha só, sempre Tributável (é a retenção)
            linhas = linhas
                .filter(linha => !ehLinhaIss(linha) || linha === linhasIss[0])
                .map(linha => linha === linhasIss[0] ? { ...linha, situacao: { label: 'Tributável', value: 1 }, disabled: true } : linha)
        } else {
            let tributoIss = null
            try {
                tributoIss = await buscarTributoIss(propsFormik.values.municipio?.value, propsFormik.values.data_emissao)
            } catch (e) {
                mostrarToast('erro', mensagens.erro)
                return
            }
            if (!tributoIss) {
                mostrarToast('erro', 'Não há tributo de ISS cadastrado para lançar a retenção.')
                return
            }
            // Depois do await vale o estado mais recente: pode ter desmarcado ou outra
            // chamada já ter incluído a linha enquanto buscava
            propsFormik = formikRef.current || propsFormik
            if (!propsFormik.values.iss_retido || (propsFormik.values.tributos || []).some(ehLinhaIss)) return
            linhas = propsFormik.values.tributos || []
            // Antes da linha vazia do fim (a de inclusão de tributo)
            const ultima = linhas[linhas.length - 1]
            linhas = ultima && !ultima.tributo
                ? [...linhas.slice(0, -1), linhaIssNova(tributoIss), ultima]
                : [...linhas, linhaIssNova(tributoIss)]
        }

        propsFormik.values.tributos = linhas
        propsFormik.setFieldValue('tributos', linhas)
        // Os índices mudaram: os valores digitados por posição não valem mais
        inputValorTributo.current = []
        calcularValorTributo(propsFormik)
    }

    const marcarIssRetido = (propsFormik, retido) => {
        propsFormik.setFieldValue('iss_retido', retido)
        propsFormik.values.iss_retido = retido
        return sincronizarLinhaIss(propsFormik)
    }

    // Troca de cliente ou empresa: a flag volta para o que o cadastro do tomador sugere
    const sugerirIssRetido = async (propsFormik, cliente, empresa) => {
        try {
            const substituto = await consultarTomadorSubstituto(cliente, empresa)
            if (substituto !== null) await marcarIssRetido(formikRef.current || propsFormik, substituto)
        } catch (e) {
            setSubstitutoCadastro(null)
            mostrarToast('erro', 'Não foi possível consultar se o tomador é substituto tributário. Confira a flag "ISS retido".')
        }
    }

    // So entra na deducao o que o tomador REALMENTE retem — deducao e "dinheiro que o
    // cliente nao te paga porque recolhe no seu lugar". Regra validada em cinco DANFSe:
    // CBS/IBS nunca; IRRF/CP sempre; ISS so com a flag "ISS retido"; PIS/COFINS exigem
    // apuracao + retencao; CSLL so a retencao (no DPS e campo proprio, vRetCSLL).
    // O que cada Tipo de Retencao retem vem do cadastro (retem_pis/retem_cofins/retem_csll).
    const linhaEntraNaDeducao = (propsFormik, linha) => {
        const nome = linha?.tributo?.tipo_tributo?.toUpperCase();

        if (nome === 'CBS' || nome === 'IBS') return false;
        if (nome === 'IR' || nome === 'INSS') return true;
        if (nome === 'ISS') return !!propsFormik.values.iss_retido;

        if (nome === 'PIS' || nome === 'COFINS' || nome === 'CSLL') {
            const retencao = propsFormik.values.pis_cofins_csll_tipo_retencao;
            if (!retencao) return false;
            if (nome === 'CSLL') return retencao.retem_csll === true;
            const apura = apuraPisCofinsSelecionado(propsFormik);
            return nome === 'PIS' ? (apura && retencao.retem_pis === true) : (apura && retencao.retem_cofins === true);
        }

        return true; // tributo fora do dominio conhecido: mantem o comportamento antigo
    }

    // Sem aviso local de coerência entre Situação Tributária / Tipo de Retenção e a grade
    // (igual ao SGCM, decisão do PO): se faltar PIS/COFINS/CSLL, quem recusa é a prefeitura
    // (E0684/E0690/E0724) e o usuário vê o retorno dela nos erros da nota.

    // CBS e IBS sao tributos "por fora": nao incidem sobre ISS, PIS e COFINS.
    // A prefeitura calcula sobre (valor do servico - esses tributos), retidos ou nao —
    // comprovado em homologacao. Sem isso o valor gravado aqui diverge do oficial da NFS-e.
    const baseDoTributo = (propsFormik, tributo, baseServico) => {
        const nome = tributo?.tipo_tributo?.toUpperCase();

        // PIS e COFINS saem da Base de Calculo PIS/COFINS (campo proprio do bloco
        // Tributacao Federal), que pode ser menor que o valor do servico. A prefeitura
        // valida que valor = base x aliquota e recusa com E0694 se nao fechar.
        // CSLL, IR e INSS nao entram aqui: no DPS sao valor direto, sem base nem aliquota.
        if (nome === 'PIS' || nome === 'COFINS') {
            const basePisCofins = convertValueToFloat(propsFormik.values.base_calculo_pis_cofins || 0);
            return basePisCofins > 0 ? basePisCofins : baseServico;
        }

        if (nome !== 'CBS' && nome !== 'IBS') return baseServico;

        // ISS apurado pela alíquota da atividade: a prefeitura o tira da base em TODA nota
        // tributável, retida ou nao, mesmo sem linha de ISS na grade (GC NFS-e 520/521,
        // producao). Sem alíquota na atividade, vale a linha de ISS (regra antiga).
        // PIS/COFINS so quando a Situacao Tributaria pede apuracao — sem apuracao eles nem
        // vao no payload e a prefeitura calcula a base sobre o valor cheio (nota 4854).
        const apura = apuraPisCofinsSelecionado(propsFormik);
        const aliquotaIss = aliquotaIssApurado(propsFormik);
        const issApurado = aliquotaIss !== null ? arredondarBancario(baseServico * (aliquotaIss / 100), 2) : 0;
        const reduzemBase = [...(aliquotaIss === null ? ['ISS'] : []), ...(apura ? ['PIS', 'COFINS'] : [])];
        const totalReduz = issApurado + (propsFormik.values.tributos || [])
            .filter(x => reduzemBase.includes(x?.tributo?.tipo_tributo?.toUpperCase()))
            .reduce((soma, x) => soma + convertValueToFloat(x?.valor_tributo || 0), 0);

        const base = baseServico - totalReduz;
        return base > 0 ? base : 0;
    }

    // Alíquota (fração) de uma linha: o ISS pela atividade municipal; os demais pela do tributo
    const aliquotaDaLinha = (propsFormik, tributo) => {
        if (tributo?.tipo_tributo?.toUpperCase() === 'ISS') {
            const aliquotaIss = aliquotaIssApurado(propsFormik)
            if (aliquotaIss !== null) return aliquotaIss / 100
        }
        return convertValueToFloat(tributo?.aliquota || 0) / 100
    }

    // Os cálculos sempre usam o estado mais recente do formulário. Quem chama depois de um
    // await (cascata CNAE -> serviço -> NBS -> indicador -> classificação, consulta do tomador)
    // traz o propsFormik de quando começou — se o lançamento foi escolhido no meio, esse
    // retrato ainda tinha a base vazia, e o cálculo zerava CBS/IBS e deixava o Valor Nota NaN.
    // Em handler síncrono, formikRef.current é o mesmo propsFormik.
    const formikAtual = (propsFormik) => formikRef.current || propsFormik

    const calcularValorTributo = (propsFormikChamada, idx) => {
        const propsFormik = formikAtual(propsFormikChamada)
        let aliquota, valorTributo = 0

        if (idx) {

            aliquota = aliquotaDaLinha(propsFormik, propsFormik.values.tributos[idx]?.tributo)
            aliquota = aplicarReducaoIbsCbs(propsFormik, propsFormik.values.tributos[idx]?.tributo, aliquota)
            // Bancario, nao toFixed: a prefeitura arredonda metade-para-o-par e a Focus
            // recusa com E0694 quando valor != base x aliquota.
            valorTributo = arredondarBancario((baseDoTributo(propsFormik, propsFormik.values.tributos[idx]?.tributo, convertValueToFloat(propsFormik.values.valor_base_calculo || valorTotalLancamentos)) * aliquota) || 0, 2)
            propsFormik.setFieldValue(`tributos[${idx}].valor_tributo`, valorTributo)
            propsFormik.setFieldValue(`tributos[${idx}].valor_tributo_formatado`, formatarMoeda(valorTributo))
            propsFormik.values.tributos[idx].valor_tributo = valorTributo
            inputValorTributo.current[idx] = valorTributo
        } else {
            // CBS e IBS por ULTIMO: a base deles desconta ISS/PIS/COFINS, entao esses tres
            // precisam ja estar recalculados nesta mesma passada. Como os obrigatorios
            // (CBS/IBS) sao inseridos no inicio do array, a ordem natural dava a eles os
            // valores da passada anterior.
            //
            // O par {x, idx} tambem corrige um erro antigo: o indice vinha do array JA
            // filtrado e era usado contra o array completo, entao qualquer linha sem
            // tributo deslocava as gravacoes pra posicao errada.
            const ehIbsCbs = (linha) => ['CBS', 'IBS'].includes(linha?.tributo?.tipo_tributo?.toUpperCase())

            propsFormik.values.tributos
                .map((x, idx) => ({ x, idx }))
                .filter(({ x }) => x.tributo)
                .sort((a, b) => (ehIbsCbs(a.x) ? 1 : 0) - (ehIbsCbs(b.x) ? 1 : 0))
                .forEach(({ x, idx }) => {
                    let aliquotaBase = aliquotaDaLinha(propsFormik, x?.tributo)
                    let aliquotaEfetiva = aplicarReducaoIbsCbs(propsFormik, x?.tributo, aliquotaBase)
                    valorTributo = arredondarBancario((baseDoTributo(propsFormik, x?.tributo, convertValueToFloat(propsFormik.values.valor_base_calculo)) * aliquotaEfetiva) || 0, 2)
                    propsFormik.setFieldValue(`tributos[${idx}].valor_tributo`, valorTributo)
                    propsFormik.setFieldValue(`tributos[${idx}].valor_tributo_formatado`, formatarMoeda(valorTributo))
                    propsFormik.values.tributos[idx].valor_tributo = valorTributo
                    inputValorTributo.current[idx] = valorTributo
                })

        }
        calculaTodosTributos(propsFormik)
    }
    const calculaTodosTributos = (propsFormikChamada) => {
        const propsFormik = formikAtual(propsFormikChamada)

        // CBS/IBS sempre refeitos aqui: a base deles desconta ISS/PIS/COFINS, então incluir,
        // remover ou editar uma dessas linhas muda o valor deles (antes só a linha mexida era
        // recalculada e o CBS/IBS ficava com o valor velho até o servidor refazer ao salvar).
        // Não são editáveis à mão, então recalcular não apaga nada digitado.
        const baseServico = convertValueToFloat(propsFormik.values.valor_base_calculo)
        ;(propsFormik.values.tributos || []).forEach((linha, idx) => {
            if (!['CBS', 'IBS'].includes(linha?.tributo?.tipo_tributo?.toUpperCase())) return
            const aliquota = aplicarReducaoIbsCbs(propsFormik, linha.tributo, aliquotaDaLinha(propsFormik, linha.tributo))
            const valor = arredondarBancario((baseDoTributo(propsFormik, linha.tributo, baseServico) * aliquota) || 0, 2)
            propsFormik.setFieldValue(`tributos[${idx}].valor_tributo`, valor)
            propsFormik.setFieldValue(`tributos[${idx}].valor_tributo_formatado`, formatarMoeda(valor))
            propsFormik.values.tributos[idx].valor_tributo = valor
            inputValorTributo.current[idx] = valor
        })

        // So o que e retido entra na deducao (antes filtrava por !obrigatorio, que era
        // um proxy de CBS/IBS e ignorava o Tipo de Retencao e a Situacao Tributaria).
        let valoresTributos = propsFormik.values.tributos.filter(x => x?.tributo && linhaEntraNaDeducao(propsFormik, x)).map(x => convertValueToFloat(x.valor_tributo))
        let valorTodosTributos = valoresTributos.reduce((acc, valor) => acc + valor, 0)
        propsFormik.setFieldValue('valor_deducao', convertValueToFloat(valorTodosTributos))
        propsFormik.setFieldValue('valor_deducao_formatado', formatarMoeda(convertValueToFloat(valorTodosTributos)))

        propsFormik.values.valor_deducao = valorTodosTributos
        propsFormik.values.valor_deducao_formatado = formatarMoeda(valorTodosTributos)

        propsFormik.values.valor_deducao = valorTodosTributos
        let valorNota = convertValueToFloat(propsFormik.values.valor_base_calculo) - convertValueToFloat(valorTodosTributos)
        propsFormik.setFieldValue('valor_nota', valorNota)
        propsFormik.setFieldValue('valor_nota_formatado', formatarMoeda(convertValueToFloat(valorNota)))
    }

    return (
        <Formik
            innerRef={formikRef}
            initialValues={valoresIniciais}
            validationSchema={validacao}
            enableReinitialize={true}
            onSubmit={(values, propsFormik) => Submit(values, propsFormik)}>
            {(propsFormik) => {
                const temLancamentoSelecionado = false;
                // (propsFormik.values.lancamentos || []).some(
                //     (x) => !!x?.lancamento?.value
                // );

                return (
                    <Form>
                        {!props.modal && <HeaderCadastro titulo={"Cadastro Nota Fiscal"} link={links} />}
                        <div className={props.modal && props.modal || 'card mb-20'}>
                            <div className={'card-body'}>
                                <div className='row'>
                                    <InputPadrao tamanho={!props.modal && 'col-sm-12 col-lg-3 col-xl-3'} classeTooltip={props.modal && 'tooltip-input-modal'}
                                        label="Número NFS-e" name="numero" type="text" placeholder="Número NFS-e" autoFocus salvarENovo={salvarENovo} maxLength={20}
                                    />

                                    <InputPadrao label='Código Verificação' name='codigo_verificacao' placeholder="Código Verificação" propsFormik={propsFormik} maxLength={20}
                                        classeTooltip={props.modal && 'tooltip-input-modal'} tamanho={!props.modal && 'col-lg-2'} />

                                    <InputDatePicker label='Data Emissão' placeholder='Data Emissão' name='data_emissao' propsFormik={propsFormik} tamanho={!props.modal && 'col-lg-2'}
                                        setarValor={value => {
                                            propsFormik.setFieldValue("data_emissao", value)
                                        }}
                                        onChange={value => sincronizarTributosObrigatorios(propsFormik, propsFormik.values.municipio, value)} />

                                    <InputClienteFinanceiroV3 label='Tomador/Cliente' name="cliente" placeholder="Tomador/Cliente" propsFormik={propsFormik} obrigatorio={true}
                                        onChange={(value) => {
                                            propsFormik.setFieldValue('cliente', value);
                                            propsFormik.setFieldValue('lancamentos', [{ lancamento: undefined, valor_lancamento: 0, valor_lancamento_formatado: 'R$ 0,00' }])
                                            const retencaoPadrao = calcularRetencaoPadraoPisCofinsCsll(propsFormik.values.empresa, value);
                                            if (retencaoPadrao !== undefined) propsFormik.setFieldValue('pis_cofins_csll_tipo_retencao', retencaoPadrao);
                                            propsFormik.values.cliente = value
                                            sugerirIssRetido(propsFormik, value, propsFormik.values.empresa)
                                        }} idTela={id} rotaTela='/financeiro/alterarTomadorNotaFiscal'
                                        botaoVisivel={true} changeIcon={'icon-Pencil'}
                                        tamanho={!props.modal && 'col-lg-5'} classeTooltip={props.modal && 'tooltip-input-modal'} additionalValues={'identificacao'} />

                                    <InputEmpresaCliente
                                        label='Prestador/Empresa'
                                        name="empresa"
                                        placeholder="Prestador/Empresa"
                                        propsFormik={propsFormik}
                                        obrigatorio={true}
                                        tamanho={!props.modal && 'col-lg-4'}
                                        disabled={temLancamentoSelecionado || !!idSubstituicao}
                                        classeTooltip={props.modal && 'tooltip-input-modal'}
                                        onChange={(empresa) => {
                                            propsFormik.setFieldValue('empresa', empresa)
                                            propsFormik.setFieldValue('cnae', null)
                                            propsFormik.setFieldValue('lista_servico', null)
                                            propsFormik.setFieldValue('nbs', null)
                                            propsFormik.setFieldValue('empresa_atividade_municipal', null)
                                            cascataAposServicoNbs(propsFormik, null, null)
                                            const retencaoPadrao = calcularRetencaoPadraoPisCofinsCsll(empresa, propsFormik.values.cliente);
                                            if (retencaoPadrao !== undefined) propsFormik.setFieldValue('pis_cofins_csll_tipo_retencao', retencaoPadrao);
                                            // Sem atividade não há alíquota de ISS; a flag volta para a sugestão do tomador nesta empresa
                                            propsFormik.values.empresa = empresa
                                            propsFormik.values.empresa_atividade_municipal = null
                                            calcularValorTributo(propsFormik)
                                            sugerirIssRetido(propsFormik, propsFormik.values.cliente, empresa)
                                        }}
                                    />

                                    <InputNaturezaOperacao
                                        label="Natureza da Operação"
                                        name="natureza_operacao"
                                        placeholder="Natureza da Operação"
                                        propsFormik={propsFormik}
                                        obrigatorio={true}
                                        tamanho={!props.modal && 'col-lg-4'}
                                        classeTooltip={props.modal && 'tooltip-input-modal'}
                                        empresa={propsFormik.values.empresa}
                                        onChangeValue={(option) => {
                                            // Só Operação tributável tem ISS (base do IBS/CBS e linha retida)
                                            propsFormik.values.natureza_operacao = option
                                            calcularValorTributo(propsFormik)
                                        }}
                                    />


                                    <InputCnaeByEmpresa
                                        label="CNAE"
                                        name="cnae"
                                        placeholder="CNAE"
                                        propsFormik={propsFormik}
                                        obrigatorio={true}
                                        empresa={propsFormik.values.empresa}
                                        tamanho={!props.modal && 'col-lg-4'}
                                        classeTooltip={props.modal && 'tooltip-input-modal'}
                                        onChangeValue={() => {
                                            propsFormik.setFieldValue('lista_servico', null)
                                            propsFormik.setFieldValue('nbs', null)
                                            cascataAposServicoNbs(propsFormik, null, null)
                                        }}
                                    />

                                    <InputListaServicoByCnae
                                        label="Lista Serviço"
                                        name="lista_servico"
                                        placeholder="Lista Serviço"
                                        obrigatorio={true}
                                        propsFormik={propsFormik}
                                        cnae={propsFormik.values.cnae}
                                        tamanho={!props.modal && 'col-lg-4'}
                                        classeTooltip={props.modal && 'tooltip-input-modal'}
                                        onChangeValue={(listaServico) => {
                                            propsFormik.setFieldValue('nbs', null)
                                            cascataAposServicoNbs(propsFormik, null, null)
                                            sugerirAtividadePelaLista(propsFormik, listaServico)
                                        }}
                                    />

                                    <InputNbsByListaServico
                                        label="NBS"
                                        name="nbs"
                                        placeholder="NBS"
                                        obrigatorio={true}
                                        propsFormik={propsFormik}
                                        listaServico={propsFormik.values.lista_servico}
                                        tamanho={!props.modal && 'col-lg-4'}
                                        classeTooltip={props.modal && 'tooltip-input-modal'}
                                        onChangeValue={(nbs) => {
                                            cascataAposServicoNbs(propsFormik, propsFormik.values.lista_servico, nbs)
                                        }}
                                    />

                                    <InputAtividadeMunicipal
                                        label="Atividade Municipal"
                                        name="empresa_atividade_municipal"
                                        placeholder="Atividade Municipal"
                                        propsFormik={propsFormik}
                                        empresaId={propsFormik.values.empresa?.value}
                                        disabled={!propsFormik.values.empresa?.value}
                                        tamanho={!props.modal && 'col-lg-4'}
                                        classeTooltip={props.modal && 'tooltip-input-modal'}
                                        onChange={(option) => {
                                            // A alíquota do ISS é a da atividade (cadastro da prefeitura)
                                            propsFormik.values.empresa_atividade_municipal = option
                                            calcularValorTributo(propsFormik)
                                        }}
                                    />

                                    <InputSwitch
                                        label='ISS Retido (pelo tomador)'
                                        name='iss_retido'
                                        propsFormik={propsFormik}
                                        quebrarLinha
                                        classeDiv='form-group'
                                        tamanho={!props.modal && 'col-lg-2'}
                                        checked={!!propsFormik.values.iss_retido}
                                        onChange={(retido) => marcarIssRetido(propsFormik, retido)}
                                    />
                                    <div className={!props.modal ? 'col-lg-6 d-flex align-items-center' : 'col-12'}>
                                        {substitutoCadastro !== null &&
                                            <span style={{ fontSize: 12, color: substitutoCadastro === !!propsFormik.values.iss_retido ? '#555' : '#c0392b' }}>
                                                {substitutoCadastro === !!propsFormik.values.iss_retido
                                                    ? <>Sugerido pelo cadastro do tomador: {substitutoCadastro ? 'substituto tributário (ISS retido).' : 'não é substituto tributário (ISS não retido).'}</>
                                                    : <><FiAlertTriangle /> Diferente do cadastro do tomador ({substitutoCadastro ? 'substituto tributário' : 'não substituto'}): a prefeitura recusa {substitutoCadastro ? 'nota sem retenção (EM059)' : 'a retenção (EM057)'}.</>}
                                            </span>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={'mt-40'}>
                            <HeaderCadastro
                                titulo={'Lançamento(s)'}
                                classeChildren='space-between-100'
                            >
                                <BotaoPadrao
                                    texto='Importar por lote'
                                    type='button'
                                    click={() => { setLoteSelecionado(null); setShowModalImportarLote(true) }}
                                />
                            </HeaderCadastro>
                        </div>
                        <div className="card mt-2">
                            <div className="card-body socio-float custom-scrollbar" ref={refLancamentos}>
                                <FieldArray name="lancamentos">
                                    {(arrayHelpers => {
                                        const valoresLancamentosSelecionados = (propsFormik.values.lancamentos || []).map(x => x.lancamento?.value)
                                        return (
                                        <>
                                            {propsFormik.values.lancamentos && propsFormik.values.lancamentos.length > 0 ?
                                                propsFormik.values.lancamentos.map((item, index) => <div className='modal-body-cadastro row mr-0 ml-0'>
                                                    <div className={"form-group col-1 pl-0 text-center"}>
                                                        <label htmlFor={props.id || props.name}>{index === 0 ? '#' : undefined}</label>
                                                        <div className={'text-center vertical-center' + (index === 0 ? ' mt-3' : '')}><span>{index + 1}</span></div>
                                                    </div>
                                                    <InputTodosLancamentoFinanceiroPorCliente valor_setado={valoresLancamentosSelecionados} label={index === 0 ? 'Lançamento' : undefined} placeholder={!propsFormik.values.cliente ? 'Adicione o Tomador/Cliente' : 'Lançamento'} name={`lancamentos[${index}].lancamento`} propsFormik={propsFormik}
                                                        disabled={!propsFormik.values.cliente} tamanho={'col-sm-12 col-xl-6 col-lg-6 col-md-5 pl-0'} {...props} obrigatorio
                                                        classeTooltip={'tooltip-input-modal'} onChange={(value) => {
                                                            propsFormik.setFieldValue(`lancamentos[${index}].lancamento`, value);
                                                            propsFormik.setFieldValue(`lancamentos[${index}].valor_lancamento`, convertValueToFloat(value?.valor_lancamento));
                                                            propsFormik.setFieldValue(`lancamentos[${index}].valor_lancamento_formatado`, value?.valor_lancamento);
                                                            const emp = value?.empresa;


                                                            const empresaOption = emp?.id
                                                                ? {
                                                                    value: emp.id,
                                                                    label: emp.cnpj && emp.nome
                                                                        ? `${emp.cnpj} - ${emp.nome}`
                                                                        : (emp.label ?? emp.nome ?? ''),

                                                                    cnpj: emp.cnpj,
                                                                    nome: emp.nome,
                                                                }
                                                                : null;
                                                            if (empresaOption != null) {
                                                                const trocouEmpresa = propsFormik.values.empresa?.value !== empresaOption.value
                                                                propsFormik.setFieldValue('empresa', empresaOption);
                                                                propsFormik.values.empresa = empresaOption
                                                                // Empresa nova: a flag "ISS retido" volta para a sugestão do tomador
                                                                if (trocouEmpresa) sugerirIssRetido(propsFormik, propsFormik.values.cliente, empresaOption)
                                                            }
                                                            propsFormik.values.lancamentos[index].valor_lancamento = convertValueToFloat(value?.valor_lancamento)
                                                            propsFormik.values.lancamentos[index].valor_lancamento_formatado = formatarMoeda(value?.valor_lancamento)
                                                            inputValorLancamento.current[index] = convertValueToFloat(value?.valor_lancamento)
                                                            somarValorLancamentos(propsFormik)
                                                            adicionarLinhaLancamento(arrayHelpers, propsFormik, index)
                                                        }} />

                                                    <InputCurrency
                                                        onUpdate={val => {
                                                            let valor = val.replace('R$', '').replace(/\./g, '').replace(',', '.')
                                                            inputValorLancamento.current[index] = valor
                                                        }}
                                                        label={index === 0 ? 'Valor R$' : undefined}
                                                        name={`lancamentos[${index}].valor_lancamento`}
                                                        classeTooltip={'tooltip-input-modal'}
                                                        propsFormik={propsFormik}
                                                        max={100000000}
                                                        value={inputValorLancamento.current[index] || propsFormik.values.lancamentos[index].valor_lancamento_formatado || propsFormik.values.lancamentos[index].valor_lancamento}
                                                        onBlur={(e) => {
                                                            if (inputValorLancamento.current[index] || inputValorLancamento.current[index] === 0) {
                                                                propsFormik.values.lancamentos[index].valor_lancamento = inputValorLancamento.current[index] && inputValorLancamento.current[index].toString().trim();
                                                                propsFormik.values.lancamentos[index].valor_lancamento_formatado = formatarMoeda(inputValorLancamento.current[index] && inputValorLancamento.current[index].toString());
                                                                somarValorLancamentos(propsFormik, true)

                                                            }
                                                            inputValorLancamento.current[index] = null;
                                                        }

                                                        } classDiv='col-4' />

                                                    <div className='col-4 col-xl-1 col-lg-2 col-md-2 mb-0 pr-0 pl-1 pb-3 content-bottom-center text-right'>
                                                        <BtnAcao type={'button'} icone="icon-New-Trash" texto="Remover" action={() => { removerLinhaLancamento(arrayHelpers, propsFormik, index) }} />
                                                    </div>
                                                </div>)
                                                :
                                                <></>}
                                        </>
                                    )})}
                                </FieldArray>
                                {propsFormik.touched.lancamentos && propsFormik.errors.lancamentos && !Array.isArray(propsFormik.errors.lancamentos) ?
                                    <Overlay target={refLancamentos.current} show={true} placement="bottom">
                                        {props2 => {
                                            return (
                                                <Tooltip id={Math.random()} className={"error-tooltip tooltip-input-modal"} {...props2}>
                                                    <div className="error">
                                                        <FiAlertTriangle className="icone" /> <span>{propsFormik.errors.lancamentos}</span></div>
                                                </Tooltip>)
                                        }}
                                    </Overlay> : <></>}
                            </div>
                        </div>

                        <ModalDuasOpcoes
                            titulo={'Importar Lançamentos por Lote'}
                            showModal={showModalImportarLote}
                            setShowModal={setShowModalImportarLote}
                            fecharModal={true}
                            salvando={importandoLote}
                            textoOpcao1={'Cancelar'}
                            classeOpcao1={'btn-sm btn-primary-modal simples'}
                            funcaoOpcao1={() => { setShowModalImportarLote(false); setLoteSelecionado(null); propsFormik.setFieldValue('lote_importar', null) }}
                            textoOpcao2={'Confirmar'}
                            classeOpcao2={'btn-sm btn-primary-modal primary'}
                            funcaoOpcao2={() => importarLancamentosDoLote(propsFormik)}
                            mensagem={
                                <div style={{ minHeight: 120 }}>
                                    <InputLoteLancamento
                                        label='Lote'
                                        name='lote_importar'
                                        placeholder='Pesquise pelo código...'
                                        tamanho='col-lg-12 p-0'
                                        classeTooltip='tooltip-input-modal'
                                        obrigatorio={true}
                                        propsFormik={propsFormik}
                                        onChange={(option) => {
                                            propsFormik.setFieldValue('lote_importar', option)
                                            setLoteSelecionado(option)
                                        }}
                                    />
                                    {loteSelecionado?.value && (
                                        <div style={{ marginTop: 10, fontSize: 12 }}>
                                            <div><b>Estabelecimento:</b> {loteSelecionado.estabelecimento || '-'}</div>
                                            <div><b>Lançamentos:</b> {loteSelecionado.qtd_lancamentos ?? 0}</div>
                                            <div><b>Valor Total:</b> {loteSelecionado.valor_total || 'R$ 0,00'}</div>
                                            <div><b>Registro:</b> {loteSelecionado.data_registro || '-'}</div>
                                        </div>
                                    )}
                                </div>
                            }
                        />

                        <div className={'mt-40'}>
                            <HeaderCadastro titulo={"Dados Serviço"} />
                        </div>
                        <div className={props.modal && props.modal || 'card mb-20'}>
                            <div className={'card-body'}>
                                <div className='row'>
                                    <InputMunicipio tamanho={!props.modal && 'col-lg-3'} label='Município - UF' name='municipio' placeholder='Município - UF' obrigatorio={true}
                                        propsFormik={propsFormik} classeTooltip={props.modal && 'tooltip-input-modal'}
                                        onChange={option => {
                                            propsFormik.setFieldValue('municipio', option)
                                            sincronizarTributosObrigatorios(propsFormik, option, propsFormik.values.data_emissao)
                                        }} />

                                    <TextArea label={<span>Discriminação Serviços</span>} obrigatorio={true} propsFormik={propsFormik} name='discriminacao_servicos' type='text' placeholder='Discriminação Serviços' tamanho={!props.modal && 'col-lg-5 p-0'} rows={3}
                                        classeTooltip={'tooltip-input-modal'}
                                    />
                                    <TextArea label={<span>Informações Adicionais</span>} name='informacoes_adicionais' type='text' placeholder='Informações Adicionais' tamanho={'col-lg-4 '} classeTooltip={'tooltip-input-modal'} />

                                    <InputCurrency
                                        onUpdate={val => {
                                            let valor = val.replace('R$', '').replace(/\./g, '').replace(',', '.')
                                            inputValor.current = valor
                                        }}
                                        label='Valor R$'
                                        name={`valor_servico`}
                                        classeTooltip={'tooltip-input-modal'}
                                        disabled={true}
                                        propsFormik={propsFormik}
                                        max={100000000}
                                        value={inputValor.current || propsFormik.values.valor_servico_formatado || propsFormik.values.valor_servico}
                                        onBlur={(e) => {
                                            if (inputValor.current || inputValor.current === 0) {
                                                propsFormik.values.valor_servico = inputValor.current && inputValor.current.toString().trim();
                                                propsFormik.values.valor_servico_formatado = formatarMoeda(inputValor.current && inputValor.current.toString());
                                            }
                                            inputValor.current = null;
                                        }

                                        } classDiv='col-4' />
                                    <InputCurrency

                                        onUpdate={val => {
                                            let valor = val.replace('R$', '').replace(/\./g, '').replace(',', '.')
                                            inputValorDesconto.current = valor
                                        }}
                                        label='Valor Desconto R$'
                                        name={`valor_desconto`}
                                        classeTooltip={'tooltip-input-modal'}
                                        propsFormik={propsFormik}
                                        max={100000000}
                                        value={inputValorDesconto.current || propsFormik.values.valor_desconto_formatado || propsFormik.values.valor_desconto}
                                        onBlur={(e) => {
                                            if (inputValorDesconto.current || inputValorDesconto.current === 0) {
                                                propsFormik.values.valor_desconto = inputValorDesconto.current && inputValorDesconto.current.toString().trim();
                                                propsFormik.values.valor_desconto_formatado = formatarMoeda(inputValorDesconto.current && inputValorDesconto.current.toString());
                                                somarValorLancamentos(propsFormik)
                                                //onChangeValorLiquidacaoNovo(propsFormik.values.liquidacao, index, propsFormik)
                                            }
                                            inputValorDesconto.current = null;
                                        }

                                        } classDiv='col-4 ' />
                                    <InputCurrency
                                        onUpdate={val => {
                                            let valor = val.replace('R$', '').replace(/\./g, '').replace(',', '.')
                                            inputBaseCalculo.current = valor
                                        }}
                                        label={`Base Cálculo R$`}
                                        negrito={true}
                                        name={`valor_base_calculo`}
                                        classeTooltip={'tooltip-input-modal'}
                                        propsFormik={propsFormik}
                                        disabled={true}
                                        max={100000000}
                                        value={inputBaseCalculo.current || propsFormik.values.valor_base_calculo_formatado || propsFormik.values.valor_base_calculo}
                                        onBlur={(e) => {
                                            if (inputBaseCalculo.current || inputBaseCalculo.current === 0) {
                                                propsFormik.values.valor_base_calculo = inputBaseCalculo.current && inputBaseCalculo.current.toString().trim();
                                                propsFormik.values.valor_base_calculo_formatado = formatarMoeda(inputBaseCalculo.current && inputBaseCalculo.current.toString());

                                            }
                                            inputBaseCalculo.current = null;
                                        }

                                        } classDiv='col-4 ' />
                                    <InputCurrency
                                        onUpdate={val => {
                                            let valor = val.replace('R$', '').replace(/\./g, '').replace(',', '.')
                                            inputValorDeducao.current = valor
                                        }}
                                        label='Valor Dedução R$'
                                        name={`valor_deducao`}
                                        classeTooltip={'tooltip-input-modal'}
                                        propsFormik={propsFormik}
                                        disabled={true}
                                        max={100000000}
                                        value={inputValorDeducao.current || propsFormik.values.valor_deducao || propsFormik.values.valor_deducao_formatado}
                                        onBlur={(e) => {
                                            if (inputValorDeducao.current || inputValorDeducao.current === 0) {
                                                propsFormik.values.valor_deducao = inputValorDeducao.current && inputValorDeducao.current.toString().trim();
                                                propsFormik.values.valor_deducao_formatado = formatarMoeda(inputValorDeducao.current && inputValorDeducao.current.toString());

                                                //onChangeValorLiquidacaoNovo(propsFormik.values.liquidacao, index, propsFormik)
                                            }
                                            inputValorDeducao.current = null;
                                        }

                                        } classDiv='col-4 ' />
                                    <InputCurrency
                                        onUpdate={val => {
                                            let valor = val.replace('R$', '').replace(/\./g, '').replace(',', '.')
                                            inputValorNota.current = valor
                                        }}
                                        label='Valor Nota R$'
                                        negrito={true}
                                        name={`valor_nota`}
                                        classeTooltip={'tooltip-input-modal'}
                                        propsFormik={propsFormik}
                                        disabled={true}
                                        max={100000000}
                                        value={inputValorNota.current || propsFormik.values.valor_nota || propsFormik.values.valor_nota_formatado}
                                        onBlur={(e) => {
                                            if (inputValorNota.current || inputValorNota.current === 0) {
                                                propsFormik.values.valor_nota = inputValorNota.current && inputValorNota.current.toString().trim();
                                                propsFormik.values.valor_nota_formatado = formatarMoeda(inputValorNota.current && inputValorNota.current.toString());

                                                //onChangeValorLiquidacaoNovo(propsFormik.values.liquidacao, index, propsFormik)
                                            }
                                            inputValorNota.current = null;
                                        }

                                        } classDiv='col-4' />

                                </div>
                            </div>
                        </div>

                        <div className={'mt-40'}>
                            <HeaderCadastro
                                titulo={'Tributação Federal (PIS/COFINS)'}
                                classeChildren='space-between-100'
                            />
                        </div>
                        <div className="card mt-2">
                            <div className="card-body">
                                <div className='row'>
                                    <InputPisCofinsSituacaoTributaria
                                        label='Situação Tributária do PIS/COFINS'
                                        placeholder='Situação Tributária do PIS/COFINS'
                                        name='pis_cofins_situacao_tributaria'
                                        propsFormik={propsFormik}
                                        tamanho='col-sm-12 col-lg-6'
                                        onChange={(option) => {
                                            // A situacao liga/desliga o PIS/COFINS: muda a
                                            // deducao e a base do IBS/CBS.
                                            propsFormik.values.pis_cofins_situacao_tributaria = option
                                            calcularValorTributo(propsFormik)
                                        }}
                                        classeTooltip={props.modal && 'tooltip-input-modal'}
                                    />
                                    <InputPisCofinsCsllTipoRetencao
                                        label='Tipo de Retenção do PIS/COFINS/CSLL'
                                        placeholder='Tipo de Retenção do PIS/COFINS/CSLL'
                                        name='pis_cofins_csll_tipo_retencao'
                                        propsFormik={propsFormik}
                                        tamanho='col-sm-12 col-lg-6'
                                        onChange={(option) => {
                                            // Trocar QUEM retem muda a deducao e o Valor Nota.
                                            propsFormik.values.pis_cofins_csll_tipo_retencao = option
                                            calcularValorTributo(propsFormik)
                                        }}
                                        classeTooltip={props.modal && 'tooltip-input-modal'}
                                    />
                                    {/* Sugere a base da nota; o usuário pode editar. Vai no payload
                                        quando a Situação Tributária pedir apuração. */}
                                    <InputValorNovo
                                        label='Base de Cálculo PIS/COFINS'
                                        placeholder='Base de Cálculo PIS/COFINS'
                                        name='base_calculo_pis_cofins'
                                        propsFormik={propsFormik}
                                        /* InputValorNovo e CONTROLADO: sem o value o campo congela
                                           no default e a digitacao nao gruda (todos os usos do
                                           sistema passam value={formatado || cru}) */
                                        value={propsFormik.values.base_calculo_pis_cofins_formatado || propsFormik.values.base_calculo_pis_cofins}
                                        tamanho='col-sm-12 col-lg-6'
                                        classeTooltip={props.modal && 'tooltip-input-modal'}
                                        onBlur={() => {
                                            propsFormik.setFieldValue('base_pis_cofins_editada', true)
                                            propsFormik.values.base_pis_cofins_editada = true
                                            // Refaz as linhas de PIS/COFINS sobre a base nova — e,
                                            // em seguida, CBS/IBS, cuja base desconta esses valores.
                                            calcularValorTributo(propsFormik)
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className={'mt-40'}>
                            <HeaderCadastro
                                titulo={'Imposto e Contribuição sobre Bens e Serviços (IBS/CBS)'}
                                classeChildren='space-between-100'
                            />
                        </div>
                        <div className="card mt-2">
                            <div className="card-body">
                                <div className='row'>
                                    <InputIbsCbsIndicadorOperacao
                                        label='Indicador da Operação'
                                        placeholder={propsFormik.values.lista_servico?.value && propsFormik.values.nbs?.value ? 'Indicador da Operação' : 'Selecione Lista Serviço e NBS'}
                                        name='ibs_cbs_indicador_operacao'
                                        propsFormik={propsFormik}
                                        tamanho='col-sm-12 col-lg-4'
                                        classeTooltip={props.modal && 'tooltip-input-modal'}
                                        listaServicoId={propsFormik.values.lista_servico?.value}
                                        nbsId={propsFormik.values.nbs?.value}
                                        disabled={!propsFormik.values.lista_servico?.value || !propsFormik.values.nbs?.value}
                                        onChange={(value) => {
                                            propsFormik.setFieldValue('ibs_cbs_indicador_operacao', value);
                                            cascataAposIndicador(propsFormik, propsFormik.values.lista_servico, propsFormik.values.nbs, value);
                                        }}
                                    />
                                    <InputIbsCbsClassificacaoTributaria
                                        label='Classificação Tributária'
                                        placeholder={propsFormik.values.ibs_cbs_indicador_operacao?.value ? 'Classificação Tributária' : 'Selecione o Indicador da Operação'}
                                        name='ibs_cbs_classificacao_tributaria'
                                        propsFormik={propsFormik}
                                        tamanho='col-sm-12 col-lg-4'
                                        classeTooltip={props.modal && 'tooltip-input-modal'}
                                        listaServicoId={propsFormik.values.lista_servico?.value}
                                        nbsId={propsFormik.values.nbs?.value}
                                        indicadorId={propsFormik.values.ibs_cbs_indicador_operacao?.value}
                                        disabled={!propsFormik.values.ibs_cbs_indicador_operacao?.value}
                                        onChange={(value) => {
                                            selecionarClassificacao(propsFormik, value);
                                        }}
                                    />
                                    <InputIbsCbsSituacaoTributaria
                                        label='Situação Tributária (CST)'
                                        placeholder='Derivada da Classificação'
                                        name='ibs_cbs_situacao_tributaria'
                                        propsFormik={propsFormik}
                                        tamanho='col-sm-12 col-lg-4'
                                        classeTooltip={props.modal && 'tooltip-input-modal'}
                                        disabled={true}
                                    />
                                </div>
                                {propsFormik.values.ibs_cbs_classificacao_tributaria?.value && (
                                    <div className='row mt-2'>
                                        <div className='col-sm-12 col-lg-6'>
                                            <label className='label-padrao'>CBS</label>
                                            <div style={{ padding: '8px 12px', background: '#f5f5f5', borderRadius: '4px', fontSize: '13px' }}>
                                                Alíquota base: <b>0,90%</b>
                                                &nbsp;|&nbsp; Redução: <b>{parseFloat(propsFormik.values.ibs_cbs_classificacao_tributaria?.percentual_reducao_cbs || 0).toFixed(2)}%</b>
                                                &nbsp;|&nbsp; Alíquota efetiva: <b>{(0.9 * (1 - (parseFloat(propsFormik.values.ibs_cbs_classificacao_tributaria?.percentual_reducao_cbs || 0) / 100))).toFixed(4)}%</b>
                                            </div>
                                        </div>
                                        <div className='col-sm-12 col-lg-6'>
                                            <label className='label-padrao'>IBS</label>
                                            <div style={{ padding: '8px 12px', background: '#f5f5f5', borderRadius: '4px', fontSize: '13px' }}>
                                                Alíquota base: <b>0,10%</b>
                                                &nbsp;|&nbsp; Redução: <b>{parseFloat(propsFormik.values.ibs_cbs_classificacao_tributaria?.percentual_reducao_ibs || 0).toFixed(2)}%</b>
                                                &nbsp;|&nbsp; Alíquota efetiva: <b>{(0.1 * (1 - (parseFloat(propsFormik.values.ibs_cbs_classificacao_tributaria?.percentual_reducao_ibs || 0) / 100))).toFixed(4)}%</b>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className={'mt-40'}>
                            <HeaderCadastro
                                titulo={'Tributo(s)'}
                                classeChildren='space-between-100'
                            />
                        </div>
                        <div className="card mt-2">
                            <div className="card-body socio-float custom-scrollbar" ref={refTributos}>
                                <FieldArray name="tributos">
                                    {(arrayHelpers => (
                                        <>
                                            {propsFormik.values.tributos && propsFormik.values.tributos.length > 0 ?
                                                propsFormik.values.tributos.map((item, index) => { const travada = item.obrigatorio || ehLinhaIss(item); return <div className='modal-body-cadastro row mr-0 ml-0'>
                                                    <div className={"form-group col-1 pl-0 text-center"}>
                                                        <label htmlFor={props.id || props.name}>{index === 0 ? '#' : undefined}</label>
                                                        <div className={'text-center vertical-center' + (index === 0 ? ' mt-3' : '')}><span>{index + 1}</span></div>
                                                    </div>

                                                    <InputSituacaoTributo label={index === 0 ? 'Situação' : undefined} placeholder='Situação' name={`tributos[${index}].situacao`} propsFormik={propsFormik}
                                                        tamanho={'col-sm-12 col-xl-2 col-lg-6 col-md-5 pl-0'} {...props} obrigatorio={propsFormik.values.tributos[index]?.tributo?.value ? true : false || propsFormik.values.tributos?.length > 1}
                                                        classeTooltip={'tooltip-input-modal'} disabled={travada} />
                                                    <InputRecolhimentoTributo label={index === 0 ? 'Recolhimento' : undefined} placeholder='Recolhimento' name={`tributos[${index}].recolhimento`} propsFormik={propsFormik}
                                                        tamanho={'col-sm-12 col-xl-2 col-lg-6 col-md-5 pl-0'} {...props} obrigatorio={propsFormik.values.tributos[index]?.tributo?.value ? true : false || propsFormik.values.tributos?.length > 1}
                                                        classeTooltip={'tooltip-input-modal'} disabled={travada} />
                                                    <InputTributo ocultarTipos={['ISS']} label={index === 0 ? 'Tributo' : undefined} municipio={propsFormik.values.municipio} dataEmissao={propsFormik.values.data_emissao} placeholder='Tributo' name={`tributos[${index}].tributo`} propsFormik={propsFormik}
                                                        tamanho={'col-sm-12 col-xl-2 col-lg-6 col-md-5 pl-0'} {...props} obrigatorio={propsFormik.values.tributos[index]?.tributo?.value ? true : false || propsFormik.values.tributos?.length > 1}
                                                        onChange={(value) => { propsFormik.values.tributos[index].tributo = value; adicionarLinhaTributo(arrayHelpers, propsFormik, index); calcularValorTributo(propsFormik, index, inputValorTributo) }}
                                                        classeTooltip={'tooltip-input-modal'} disabled={travada} />
                                                    <InputLocalIncidencia label={index === 0 ? 'Local Inc.' : undefined} placeholder='Local Inc.' name={`tributos[${index}].local_incidencia`} propsFormik={propsFormik}
                                                        tamanho={'col-sm-12 col-xl-2 col-lg-6 col-md-5 pl-0'} {...props} obrigatorio={propsFormik.values.tributos[index]?.tributo?.value ? true : false || propsFormik.values.tributos?.length > 1} isClearable={false}
                                                        classeTooltip={'tooltip-input-modal'} disabled={travada} />
                                                    <InputCurrency
                                                        onUpdate={val => {
                                                            let valor = val.replace('R$', '').replace(/\./g, '').replace(',', '.')
                                                            inputValorTributo.current[index] = valor
                                                        }}
                                                        label={index === 0 ? 'Valor Tributo R$' : undefined}
                                                        name={`tributos[${index}].valor_tributo`}
                                                        classeTooltip={'tooltip-input-modal'}
                                                        propsFormik={propsFormik}
                                                        disabled={item.disabled ?? true}
                                                        max={100000000}
                                                        value={inputValorTributo.current[index] || propsFormik.values.tributos[index].valor_tributo || propsFormik.values.tributos[index].valor_tributo_formatado}
                                                        onBlur={(e) => {
                                                            if (inputValorTributo.current[index] || inputValorTributo.current[index] === 0) {
                                                                propsFormik.values.tributos[index].valor_tributo = inputValorTributo.current[index] && inputValorTributo.current[index].toString().trim();
                                                                propsFormik.values.tributos[index].valor_tributo_formatado = formatarMoeda(inputValorTributo.current[index] && inputValorTributo.current[index].toString());
                                                                //onChangeValorLiquidacaoNovo(propsFormik.values.liquidacao, index, propsFormik)
                                                            }
                                                            inputValorTributo.current[index] = null;
                                                            calculaTodosTributos(propsFormik);
                                                        }

                                                        } classDiv='col-2' />

                                                    <div className='col-4 col-xl-1 col-lg-2 col-md-2 mb-0 pr-0 pl-1 pb-3 content-bottom-center text-right'>
                                                        {!travada && <>
                                                            <BtnAcao
                                                                type={"button"}
                                                                icone={
                                                                    item.disabled
                                                                        ? "icon-Lock"
                                                                        : "icon-Unlock"
                                                                }
                                                                texto={
                                                                    item.disabled
                                                                        ? "Desbloquear Valor Tributo"
                                                                        : "Bloquear Valor Tributo"
                                                                }
                                                                action={() => {
                                                                    propsFormik.setFieldValue(
                                                                        `tributos[${index}].disabled`,
                                                                        !(item.disabled ?? true)
                                                                    );
                                                                }}
                                                            />

                                                            <BtnAcao type={'button'} icone="icon-New-Trash" texto="Remover" action={() => { removerLinhaTributo(arrayHelpers, propsFormik, index); calculaTodosTributos(propsFormik, index, inputValorTributo) }} />
                                                        </>}
                                                        {item.obrigatorio && <span style={{ fontSize: 10, color: '#888', fontStyle: 'italic' }}>Reforma Tributária</span>}
                                                        {!item.obrigatorio && ehLinhaIss(item) && <span style={{ fontSize: 10, color: '#888', fontStyle: 'italic' }}>Flag ISS retido</span>}
                                                    </div>
                                                </div> })
                                                :
                                                <></>}
                                        </>
                                    ))}
                                </FieldArray>
                                {propsFormik.touched.tributos && propsFormik.errors.tributos && !Array.isArray(propsFormik.errors.tributos) ?
                                    <Overlay target={refTributos.current} show={true} placement="bottom">
                                        {props2 => {
                                            return (
                                                <Tooltip id={Math.random()} className={"error-tooltip tooltip-input-modal"} {...props2}>
                                                    <div className="error">
                                                        <FiAlertTriangle className="icone" /> <span>{propsFormik.errors.tributos}</span></div>
                                                </Tooltip>)
                                        }}
                                    </Overlay> : <></>}
                            </div>
                        </div>
                        {idSubstituicao && <><div className={'mt-40'}>
                            <HeaderCadastro
                                titulo={'Substituição'}
                                classeChildren='space-between-100'
                            />
                        </div>
                            <div className="card mt-2">
                                <div className="card-body">
                                    <TextArea
                                        label={'Justificativa'}
                                        type='text'
                                        name='anotacao'
                                        tamanho='col-12 pr-0'
                                        classeTooltip={'tooltip-input-modal'}
                                    />
                                </div>
                            </div></>}
                        {!props.modal && <div className='separator mt-40 mb-5'></div>}
                        <div className='direita container-botoes mb-3 group-salvar-novo'>
                            <BotaoPadrao texto='Salvar' disabled={salvando} click={_ => setSalvarENovo(false)} idTooltip={'salvar'} />
                            {(props.modal || !id) && <BotaoPadrao texto='Salvar e Novo' disabled={salvando} click={_ => setSalvarENovo(true)} idTooltip={'salvarENovo'} />}
                        </div>
                    </Form>)
            }}
        </Formik>

    );

}

export default CadastroNotaFiscal 
